//
// Common JS for all the pages
// --------------------------------------------------

import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "bootstrap/js/dist/dropdown";
import { callApsRenew, callApsUpdate, callAtsEnvelope } from "./common/fpd";
import {
	CmpCheck,
	formAddCsrfProtection,
	getCookie,
	loadScript,
	plusTwitch,
	sendPublyticsEvent,
	setCookie,
	updateGAdataLayer,
	userLogout,
	userNotifications,
} from "./common/utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// GDPR form
	const gdpr_container = document.querySelector("#_gdpr_form");
	if (gdpr_container) {
		const view_name = gdpr_container.dataset.view_name;
		const page_url = `/misc/approvazione-gdpr/?view=${encodeURI(view_name)}`;
		fetch(page_url, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		})
			.then((response) => {
				if (response.status === 200) return response.text();
			})
			.then((data) => {
				if (data) {
					let gdprLightbox = null;
					gdpr_container.insertAdjacentHTML("afterbegin", data);
					document.addEventListener("click", (event) => {
						// toggle button status
						if (
							event.target &&
							event.target.getAttribute("name") === "gdpr_approved"
						) {
							if (event.target.checked) {
								document
									.querySelector("input[name='gdpr_submit']")
									.removeAttribute("disabled");
							} else {
								document
									.querySelector("input[name='gdpr_submit']")
									.setAttribute("disabled", "disabled");
							}
							// form submit
						} else if (
							event.target &&
							event.target.tagName.toLowerCase() === "input" &&
							event.target.getAttribute("name") === "gdpr_submit"
						) {
							const gdpr_form = event.target.closest("form.gdpr_form");

							formAddCsrfProtection(gdpr_form).then((data) => {
								const formData = new FormData(gdpr_form);
								fetch(gdpr_form.getAttribute("action"), {
									headers: {
										"X-Requested-With": "XMLHttpRequest",
									},
									method: "POST",
									cache: "no-cache",
									body: formData,
								})
									.then((response) => {
										if (response.ok) {
											return response.json();
										}
									})
									.then((data) => {
										if (data.show_gdpr === 0) {
											gdprLightbox.close();
										}
									})
									.catch((error) => {
										console.warn(" --- Error: ", error);
									});
							});
						}
					});

					// lightbox
					import("basiclightbox").then((basicLightbox) => {
						gdprLightbox = basicLightbox.create(gdpr_container);
						gdprLightbox.show();
					});
				}
			})
			.catch((error) => {
				console.warn(error);
			});
	}

	// USER NAV
	const user_nav = document.querySelector("#user_nav");
	if (user_nav) {
		fetch(user_nav.dataset.url, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		})
			.then((response) => response.json())
			.then((data) => {
				user_nav.innerHTML = data.html;

				// Setup logout form
				userLogout();

				// GA4
				updateGAdataLayer("datalayer_update", "user", {
					status: data.user_status,
				});
				sendPublyticsEvent("user", { user_status: data.user_status });

				// event listeners for user notifications
				userNotifications();

				if (
					!!document.querySelector("#login_registration_container") &&
					!!document.querySelector("#user_nav #_user_panel_container") === false
				) {
					window.globalLoginWindowHandler.userNavigationLogin(
						document.querySelectorAll("#user_nav"),
					);
				}
				const userNavReady = new Event("usernavready");
				document.dispatchEvent(userNavReady);

				// FPD calls
				if (data.identifier) {
					callAtsEnvelope(data.identifier);
					if (getCookie(FPD_COOKIE)) {
						callApsUpdate(data.identifier);
						setCookie(FPD_COOKIE, "", 0);
					} else {
						callApsRenew(data.identifier);
					}
				}

				// setup Twitch Plus button
				plusTwitch(data.user_status);
			})
			.catch((error) => {
				console.warn(error);
			});

		document.addEventListener("usernavready", () => {
			if (document.querySelector("#user_nav #_user_panel_container")) {
				globalLoginWindowHandler.removeEventHandlers();
			}
		});
	}

	// Live Menu
	const live_menu = document.querySelector("#_live_menu");
	if (live_menu) {
		const calendar = document.querySelector("#_live_calendar");
		const live_player = document.querySelector("#_live_player");
		fetch(`/misc/live_or_shout/?calendar=${!!calendar}`, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.live_menu) {
					live_menu.innerHTML = data.live_menu;
				}
				if (!!calendar && !!live_player && data.custom_live_home) {
					live_player.insertAdjacentHTML("beforebegin", data.custom_live_home);
				}
				if (data.today_lives.length) {
					if (calendar) {
						for (const live of data.today_lives) {
							const p = document.createElement("p");
							p.classList.add("pt-1", "pb-2", "m-0", "font-weight-bold");
							p.innerHTML = `<small class='font-weight-bold'>${live.date}</small> <br>${live.name}`;
							calendar.appendChild(p);
						}
						calendar.parentNode.classList.remove("d-none");
					}
				} else if (
					(data.channel_url || data.channel) &&
					data.broadcast &&
					live_player
				) {
					const optoutCookieName = "live-optout";
					const optout = getCookie(optoutCookieName);
					const playerContainer = document.querySelector(
						"#_live_player_container",
					);
					const title = live_player.querySelector(".live__title");
					const button = live_player.querySelector(".live__header__right");
					const sign = live_player.querySelector(".live__header__left");
					const hide = () => {
						live_player.removeChild(playerContainer);
						button.querySelector(".ico-arrow").classList.add("rotate");
						button.innerHTML = button.innerHTML.replace("NASCONDI", "VAI");
						sign.classList.add("animate");
					};
					title.textContent = data.broadcast.name;
					button.addEventListener("click", () => {
						if (document.querySelector("#_live_player_container")) {
							hide();
							setCookie(optoutCookieName, data.broadcast.id, 1);
						} else {
							window.location = "/live/";
						}
					});
					if (optout === data.broadcast.id) {
						hide();
					} else {
						let channel_url = data.channel_url;
						const iframe = playerContainer.querySelector("iframe");
						if (channel_url) {
							if (data.broadcast.muted) {
								channel_url = `${data.channel_url}&muted=true`;
							}
							for (const [key, value] of Object.entries(
								data.broadcast.iframe_attrs,
							)) {
								iframe.setAttribute(key, value);
							}
							iframe.setAttribute("data-src", channel_url);
							iframe.classList.add("lazyload");
						} else {
							loadScript(
								"twitch-js",
								"https://player.twitch.tv/js/embed/v1.js",
							).then((result) => {
								const twitch_options = {
									channel: data.channel,
									parent: [data.parent],
									width: iframe.getAttribute("width"),
									height: iframe.getAttribute("height"),
									autoplay: false,
								};
								if (data.broadcast.muted) {
									twitch_options.muted = true;
								}
								playerContainer.removeChild(iframe);
								const twitchPlayer = new Twitch.Player(
									playerContainer.id,
									twitch_options,
								);
								twitchPlayer.addEventListener(Twitch.Player.ONLINE, () => {
									twitchPlayer.setQuality(playerContainer.dataset.quality);
								});
							});
						}
					}
					live_player.classList.remove("d-none");
				}
			})
			.catch((error) => {
				console.warn(error);
			});
	}

	// check plus user
	document.addEventListener("usernavready", (event) => {
		const plus = document.querySelector("#_plus_info");
		if (
			document.querySelector("#top_ads_container") &&
			plus &&
			plus.dataset.enabled === "1" &&
			plus.dataset.payer === "1"
		) {
			window.location.reload();
		}
	});

	// cmp blocked iframes
	const checkCmp = new CmpCheck();
	checkCmp.checkConsent().then((response) => {
		for (const iframe of document.querySelectorAll("._net_activate_iframe")) {
			if (iframe.classList.contains("lazyload")) {
				iframe.setAttribute("data-src", iframe.getAttribute("suppressedsrc"));
			} else {
				iframe.setAttribute("src", iframe.getAttribute("suppressedsrc"));
			}
			iframe.removeAttribute("suppressedsrc");
			iframe.classList.replace("_net_activate_iframe", "_net_activated_iframe");
		}
	});

	// Google login
	const googleButton = document.querySelector("#google-connector-button");
	if (googleButton) {
		googleButton.addEventListener("click", (event) => {
			event.preventDefault();
			const next = new URL(window.location.pathname, window.location.origin);
			window.location.href = `/registrazione-social/openid/redirect/?next=${encodeURIComponent(next.toString()) || "/"}`;
		});
	}

	window.addEventListener("gnOverlayerShow", (event) => {
		sendPublyticsEvent("gnOverlayerShow");
	});
	window.addEventListener("gnOverlayerClose", (event) => {
		sendPublyticsEvent("gnOverlayerClose");
	});
});
